import Login from '../api/login'

import router from "../router/index";

import AES from '../assets/commonjs/aes'
import {
  stat
} from 'fs';

const state = {
  title: 'login',

  info: {
    user: "",
    pwd: "",
    ad: false,
    OTP: "",
  },
  //登录接口返回的数据
  userInfo: {},
  header: {},
  tab: '',
  pwd: '',
  ADuser:'ad'
}

const getters = {

}

const mutations = {
  async get_userInfo(state) {
    let {
      user,
      pwd,
      OTP
    } = state.info

    Login.params.body.userId = user
    Login.params.body.pwd = pwd
    Login.params.body.otp_key = OTP
    let data = await Login.log_in()
    // console.log(data)
    
    if (state.pwd == AES.decrypt(data.pwd)) {
      router.push("/history");
    } else {
      alert('密码错误')
    }
    
    state.userInfo = data
    
    // console.log(state.userInfo)
    state.header = {
      sessionId: data.session_id,
      userId: data.itcode
    }
    // router.push("/history");
    state.tab = 'rong';
  },

  async checkUser(state,user){
    let params = {
      userId: "cochat",
      check_user: user
    }
    let data = await Login.checkAD(params)
    // console.log(data._data)
    state.ADuser = data._data
  }


}

const actions = {

}


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/login.js